import { action } from 'utils/actions'

export const COMMON_RESET_ERROR_MESSAGE = 'COMMON_RESET_ERROR_MESSAGE'
export const COMMON_ERROR_MESSAGE = 'COMMON_ERROR_MESSAGE'
export const COMMON_SHOW_MODAL = 'COMMON_SHOW_MODAL'
export const COMMON_HIDE_MODAL = 'COMMON_HIDE_MODAL'
export const COMMON_ENTITY_UPDATE = 'COMMON_ENTITY_UPDATE'
export const COMMON_SCROLL_PAGE = 'COMMON_SCROLL_PAGE'

export const resetErrorMessage = () => action(COMMON_RESET_ERROR_MESSAGE)
export const showErrorMessage = message => action(COMMON_ERROR_MESSAGE, { error: { detail: { message } } })
export const showModal = (modalName, modalArgs) => action(COMMON_SHOW_MODAL, { modalName, modalArgs })
export const hideModal = () => action(COMMON_HIDE_MODAL)
export const entityUpdate = entityUpdateResponse => action(COMMON_ENTITY_UPDATE, { ...entityUpdateResponse })
export const scrollPage = (x, y) => action(COMMON_SCROLL_PAGE, { x, y })



/** WEBPACK FOOTER **
 ** ./src/actions/common/common-actions.js
 **/